






























































































































































import { Component, Vue } from "vue-property-decorator";
import { storeOutpatientWaiting } from "@/store/modules/OutpatientWaitingStore";

@Component
export default class OutpatientWaitingDashboard extends Vue {
  storeModule = storeOutpatientWaiting;

  get dash() {
    return this.storeModule.dashboard || {};
  }

  get bulanIni() {
    return this.dash.bulan_ini || {};
  }

  get trend() {
    return this.dash.trend_12_bulan || [];
  }

  get topAlasan() {
    return this.dash.top_alasan_tidak_tercapai || [];
  }

  get statusColor() {
    return this.bulanIni.status_target === "tercapai" ? "green" : "red";
  }

  mounted() {
    this.storeModule.loadDashboard();
  }
}
